export interface Wallet {
  cashBalance: number;
  rewardsBalance: number;
  isCashBalanceWithdrawable: boolean;
}

export interface WalletTransaction {
  type: Transaction;
  status: TransactionStatus;
  date: Date;
  wallet: WalletType;
  amount: number;
}

export interface Card {
  network?: CardNetwork;
  cardHolderName: string;
  cardNumber: string;
  expiryMonth: number;
  expiryYear: number;
  cvv: number;
}

export interface BankAccount {
  accountName: string;
  country: string;
  currency: string;
  bankName: string;
  // branchName: string;
  // accountNumber: string;
  iban: string;
  // swiftCode: string;
}

export enum CardNetwork {
  VISA = 'visa',
  MASTERCARD = 'mastercard',
}

export enum Transaction {
  RENTAL_PAID = 'rental-paid',
  REFERRER_GIFT = 'referrer-gift',
  CASHBACK = 'cashback',
  DEPOSIT = 'deposit',
  WITHDRAWAL = 'withdrawal',
  INVESTMENT = 'investment',
}

export enum TransactionStatus {
  PROCESSING = 'processing',
  COMPLETED = 'completed',
}

export enum WalletType {
  REWARDS_BALANCE = 'rewards-balance',
  CASH_BALANCE = 'cash-balance',
}
